// extracted by mini-css-extract-plugin
export default {"card":"rezQkdg7AhaAhTORKyXF"};